// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","icon":"Header_icon__V9Fg3","game-board-stats":"Header_game-board-stats__3SIHf","button":"Header_button__AsXVL"};